"use strict";

import Swiper from 'swiper';
import 'bootstrap';
import AOS from 'aos';
import ScrollPlay from './scrollPlay';

window.Swiper = Swiper;
window.AOS = AOS;
window.ScrollPlay = ScrollPlay;

$( document ).ready(function() {
  // AOS
  AOS.init({
    duration: 1200,
  });
  window.addEventListener('scroll', function(){
    AOS.refresh(); // 스크롤이 짧았을 때 aos가 늦게 노출되는 이슈
  });
  

  // 사이드메뉴
  $(function(){
    var targetControlMenu = $(".container-doc");
    $(".doc-header .btn-menu").on("click", function(){
      targetControlMenu.stop().removeClass("menu-close-animate").addClass("menu-open-animate").addClass("menu-on");
      $("html").addClass("dimmed");
      setTimeout (
        function() {
          targetControlMenu.removeClass("menu-open-animate");
        }, 1600
      );
    })
  
    $(".menu-side .btn-close").on("click", function(){
      targetControlMenu.stop().removeClass("menu-open-animate").addClass("menu-close-animate");
      setTimeout (
        function() {
          targetControlMenu.removeClass("menu-on").removeClass("menu-close-animate");
          $("html").removeClass("dimmed");
        }, 1000
      );
    })

    var btnMenu = $(".menu-side .link-main, .menu-side .link-menu")
    btnMenu.on("click", function(){
      var targetUrl = $(this).attr('href');
      targetControlMenu.stop().removeClass("menu-open-animate").addClass("menu-close-animate");
      setTimeout (
        function() {
          targetControlMenu.removeClass("menu-on").removeClass("menu-close-animate");
          $("html").removeClass("dimmed");
          $(location).attr("href", targetUrl)
        }, 1000
      );
      return false;
    })

    var btnShare = $(".menu-side .btn-share")
    btnShare.on("click", function(){
      targetControlMenu.stop().removeClass("menu-open-animate").addClass("menu-close-animate");
      setTimeout (
        function() {
          targetControlMenu.removeClass("menu-on").removeClass("menu-close-animate");
          $("html").removeClass("dimmed");
          $('#sns-share').modal();
        }, 1000
      );
    })

    var btnSnsShare = $(".doc-header .btn-sns-share")
    btnSnsShare.on("click", function(){
      $('#sns-share').modal();
      console.log('ss')
    })
  });

  // 서브메뉴
  $(function() {
    var targetSnb = $(".menu-snb");
    var targetHeader = $(".cont-mma .doc-header");
    var classHeaderType = "transparent-visible";
    var topCurrent = $(document).scrollTop();
    // var posSnb = targetSnb.offset().top;
    // var headerHeight = targetHeader.find(".doc-title").innerHeight();
    // var activePos = posSnb - headerHeight;
    var activePos = 52;
    if (topCurrent > activePos) {
      targetSnb.addClass('fix');
      targetHeader.addClass(classHeaderType);
    } else {
      targetSnb.removeClass('fix');
      targetHeader.removeClass(classHeaderType);
    }
    $(window).on('scroll',function() {
      var topCurrent = $(document).scrollTop();
      var opacityTitle = 1 - (topCurrent/activePos);
      var targetTitle = $(".cont-mma .tit-mma, .notice .tit-g");
      if (topCurrent > activePos) {
        targetSnb.addClass('fix');
        targetHeader.addClass(classHeaderType);
      } else {
        targetSnb.removeClass('fix');
        targetHeader.removeClass(classHeaderType);
        targetTitle.css("opacity", opacityTitle);
      }
    });


  });

  // 현재 활성화 된 메뉴로 스크롤 위치 조정
  $(function(){
    var activeListMenu = document.querySelector('.list-menu li.on');
    if(activeListMenu) activeListMenu.scrollIntoView({ block: 'center' });
  })


  // footer
  $(function(){
    // var topPosition = $("#mainContent").offset().top;
    var topPosition = 0;
    $(".doc-footer .btn-top").on("click", function(){
      $("html, body").animate({scrollTop:topPosition}, 500);
    })
  });
    
  // main 알림 버튼 on
  // $(function(){
  //   var alarmBtn = $(".intro-schedule .btn-alarm");
  //   alarmBtn.on('click', function() {
  //     $(this).addClass("on")
  //   })
  // });


  // bottomsheet sort
  $(function() {
    $(".list-sort .btn-sort").on("click", function(){
      $(this).closest("li").siblings().find(".btn-sort").removeClass("on");
      $(this).addClass("on");
    })
  });

  // 공지사항
  $('.notice').on('click','.notice-question',function(e){
		e.preventDefault();
    $(this).next(".notice-answer").slideToggle(100).parents('li').toggleClass('on');
	});

  // 안내
  $(function(){
    $(".box-info-section .btn-more").on("click", function(){
      $(this).closest(".box-info-section").removeClass("overflow");
    })
  });

  $(function(){
    $(window).on('scroll',function() {
      var topCurrent = $(document).scrollTop();
      var topVisual = topCurrent / 3 
      if (topCurrent < 400) {
        $(".info-kv .img-visual").css("margin-top", topVisual + "px");
      }
    });
  });

  //modal header border 추가
  $(function(){
    $(".modal-body").on("scroll", function(){
      $(this).parents(".modal").addClass("scroll");      
      const topModalBody = $(this).scrollTop();
      if (topModalBody == 0) {
        $(".modal").removeClass("scroll")
      }
    }); 
  });
});
// 251010 [MELONUIT-2818] 모바일 스크립트 미동작이슈 수정 시작
window.marquee = {
  init: function () {
    var element = $('.marquee:not(.ani)');
    var _this = this;
    element.each(function (i) {
      // 기존에 적용된 marquee 구조가 있다면 초기화 (리사이즈 대응)
      if (this.querySelector('.origin')) {
          this.innerHTML = this.querySelector('.origin').innerHTML;
          this.classList.remove('ani');
      }

      if (_this.isElementOverflowing(this)) {
        _this.wrapContentsInMarquee(this);
      }
    });

  },
  isElementOverflowing: function (element) {
    // Math.ceil을 사용하여 소수점 차이로 인한 오류 가능성을 줄입니다.
    var overflowX = Math.ceil(element.scrollWidth) > element.offsetWidth;
    return overflowX;
  },
  wrapContentsInMarquee: function (element) {
    var marquee = document.createElement('span'),
        clone = document.createElement('span'),
        contents = element.innerHTML;

    marquee.className = 'origin';
    marquee.innerHTML = contents;
    clone.className = 'clone';
    clone.innerHTML = contents;
    element.innerHTML = '';
    element.appendChild(marquee);
    element.appendChild(clone);
    element.className = 'marquee ani';
    
    // marquee.offsetWidth가 0으로 계산되는 경우를 대비
    var marqueeWidth = marquee.offsetWidth;
    if (marqueeWidth > 0) {
      var duration = (marqueeWidth / 50) + 's';
      marquee.style.animationDuration = duration;
      clone.style.animationDuration = duration;
    }
  }
}

// Debounce를 위한 변수
var resizeTimer;

// 페이지 로드 완료 시 최초 실행
$(window).on('load', function() {
  window.marquee.init();
});

// 화면 리사이즈 시 0.25초 후 실행 (과도한 실행 방지)
$(window).on('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
      window.marquee.init();
  }, 250);
});
// 251010 [MELONUIT-2818] 모바일 스크립트 미동작이슈 수정 끝
// 251016 [MELONUIT-2822] 뮤직웨이브 라이브채팅 > 스크롤 그라데이션 추가 시작
document.addEventListener('DOMContentLoaded', () => {
  // 필요한 DOM 요소들을 선택합니다.
  const areaChat = document.querySelector('.area-chat');
  const innerChat = document.querySelector('.inner-chat');

  // 요소가 없는 경우를 대비한 방어 코드
  if (!areaChat || !innerChat) {
    return;
  }

  innerChat.scrollTop = innerChat.scrollHeight;

  const handleScroll = () => {
    const scrollTop = innerChat.scrollTop; // 현재 스크롤 위치
    const scrollHeight = innerChat.scrollHeight; // 스크롤 가능한 전체 높이
    const clientHeight = innerChat.clientHeight; // 요소의 보이는 영역 높이

    // 부동 소수점 오차를 고려하여 1px 정도의 여유를 둡니다.
    const isAtBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    // 1. 스크롤이 최상단에 있을 때
    if (scrollTop === 0) {
      areaChat.classList.add('is-scrolled-top');
      areaChat.classList.remove('is-scrolled-bottom');
    }
    // 2. 스크롤이 최하단에 있을 때
    else if (isAtBottom) {
      areaChat.classList.add('is-scrolled-bottom');
      areaChat.classList.remove('is-scrolled-top');
    }
    // 3. 스크롤이 중간에 있을 때 (둘 다 아닐 때)
    else {
      areaChat.classList.remove('is-scrolled-top', 'is-scrolled-bottom');
    }
  };

  // 스크롤 이벤트가 발생할 때마다 handleScroll 함수를 실행합니다.
  innerChat.addEventListener('scroll', handleScroll);

  // 페이지 로드 시 초기 상태를 설정하기 위해 함수를 한 번 실행합니다.
  // (채팅 내용이 적어 스크롤이 없는 경우 등을 처리)
  handleScroll();
});
// 251016 [MELONUIT-2822] 뮤직웨이브 라이브채팅 > 스크롤 그라데이션 끝
/* 251124 [MMQA-20766] 팝업 스크롤 이슈 스크립트 추가 시작 */
/**
 * Bootstrap 3.4.1 환경에서 position: fixed와 touchmove 차단을 결합하여 
 * iOS 배경 스크롤 누설을 방지하는 함수 (jQuery 필요)
 */
(function($) {
    /**
     * 터치 이동 이벤트를 처리하여 배경 스크롤을 방지하는 함수
     * @param {TouchEvent} e
     */
    function handleTouchMove(e) {
      const target = e.target; 
      const $openModal = $('.modal.in');
      if ($openModal.length === 0) return;

      const modalEl = $openModal.get(0);
      const isInsideModal = modalEl.contains(target);

      if (!isInsideModal) {
        // 모달 바깥은 스크롤 막기
        e.preventDefault();
      }
    }

    function initializeModalScrollLock() {
        const $modalElements = $('.modal');

        if ($modalElements.length === 0) return;

        $modalElements.each(function() {
            const $modalEl = $(this);

            $modalEl.on('show.bs.modal', function () {
              document.body.addEventListener('touchmove', handleTouchMove, { passive: false });
            });

            $modalEl.on('hidden.bs.modal', function () {
              document.body.removeEventListener('touchmove', handleTouchMove, { passive: false });
            });
            
            const dialogEl = $modalEl.find('.modal-dialog').get(0);
            if (dialogEl) {
              dialogEl.style.webkitOverflowScrolling = 'touch';
            }
        });
    }

    $(document).ready(initializeModalScrollLock);

})(jQuery);
/* 251124 [MMQA-20766] 팝업 스크롤 이슈 스크립트 추가 끝 */